import React from 'react';

export const Nav = (props) => {
  const menuLegend = {
    elements: ['buttons', 'checkboxes', 'inputs', 'labels', 'radio-buttons'],
    styles: ['typography', 'colors', 'icons'],
    components: ['dropdown'],
    layouts: ['placeholder', 'placeholder2']
  };

  const toggleMenuEl = (e, menuType) => {
    const activeEl = props[`active${menuType}`];
    const clickedEl = e.currentTarget.id;

    if (menuType === 'Category') {
      if (clickedEl === activeEl) {
        props.updateMainState({ [`active${menuType}`]: '' });
      } else {
        props.updateMainState({ [`active${menuType}`]: clickedEl });
      }
    } else if (menuType === 'Item') {
      let menuCategory;

      Object.keys(menuLegend).forEach((category) => {
        if (menuLegend[category].indexOf(clickedEl) >= 0) {
          menuCategory = category;
        }
      });

      props.updateMainState({ activeCategory: menuCategory, activeItem: clickedEl });
    }
  };

  const activeCategoryClass = (elClass) => (
    props.activeCategory === elClass ? 'active' : ''
  );

  const activeItemClass = (elClass) => (
    props.activeItem === elClass ? 'active' : ''
  );

  const createMenuCategory = (category) => (
    <a
      id={category}
      className={`menu-category ${activeCategoryClass(category)}`}
      onClick={(e) => toggleMenuEl(e, 'Category')}
    >
      <h3>{category}</h3>
      <span className="bff-caret-down icon" />
    </a>
  );

  const createMenuItem = (item) => (
    <li>
      <a
        id={item}
        className={`menu-item ${activeItemClass(item)}`}
        onClick={(e) => toggleMenuEl(e, 'Item')}
      >
        <p>{item}</p>
      </a>
    </li>
  );

  return (
    <section className="sidebar">
      <ul>
        <li>
          { createMenuCategory("elements") }
          <ul className="sub-menu">
            { createMenuItem("buttons") }
            { createMenuItem("checkboxes") }
            { createMenuItem("inputs") }
            { createMenuItem("labels") }
            { createMenuItem("radio-buttons") }
          </ul>
        </li>
        <li>
          { createMenuCategory("styles") }
          <ul className="sub-menu">
            { createMenuItem("typography") }
            { createMenuItem("colors") }
            { createMenuItem("icons") }
          </ul>
        </li>
        <li>
          { createMenuCategory("layouts") }
          <ul className="sub-menu">
            { createMenuItem("placeholder") }
            { createMenuItem("placeholder2") }
          </ul>
        </li>
      </ul>
    </section>
  );
};
